// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
type PtToEng = 'YES' | 'NO' | 'I DONT KNOW' | null
type EngToPt = 'SIM' | 'NAO' | 'NAO_SEI' | null

export const allergyTranslatePtToEng = (
  payload: 'SIM' | 'NAO' | 'NAO_SEI' | null,
): PtToEng => {
  if (payload === null) return null
  if (payload === 'SIM') return 'YES'
  if (payload === 'NAO') return 'NO'
  if (payload === 'NAO_SEI') return 'I DONT KNOW'
}

export const allergyTranslateEngToPt = (
  payload: 'YES' | 'NO' | 'I DONT KNOW' | null,
): EngToPt => {
  if (payload === null) return null
  if (payload === 'YES') return 'SIM'
  if (payload === 'NO') return 'NAO'
  if (payload === 'I DONT KNOW') return 'NAO_SEI'
}
